<template>
  <component
    :is="icon"
    class="c-icon"
    :class="{
      ['c-icon--' + color]: true,
      'cursor-pointer': clickable,
    }"
  />
</template>

<script>
export default {
  props: {
    icon: {
      required: true,
    },
    color: {
      type: String,
      default: 'mono-light',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
